import { useMsal } from "@azure/msal-react";
import React, { useRef } from "react";
import { FC } from "react";
import { Button } from "react-bootstrap";

const LoginForm: FC = () => {
    const { instance } = useMsal();
    const videoRef = useRef<HTMLVideoElement>(null);
    const initializeSignIn = () => {
        instance.loginRedirect();
    };

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center pb-4 pt-3 px-3"
            style={{ height: '100vh', backgroundColor: '#232222' }}
        >
            <img src="/img/Logo-w.png" height={80} width={80} alt="logo sw" className="mt-3s mb-4" />
            <h1>LOGIN</h1>
            <video ref={videoRef} width="100%" height="100%" style={{ objectFit: 'contain' }} loop autoPlay muted>
                <source src={`/mov/Loginscreen-loop.mp4`} type="video/mp4" />
            </video>
            <Button onClick={initializeSignIn} className="flex-end mb-4">Login with Microsoft</Button>
        </div>
    );
};

export default LoginForm;